import React, { useEffect, useState } from 'react';
import { Dialog } from '../Dialog/Dialog';
import { BASE_URL } from '../../../constants/Constants';
import { useNavigate } from 'react-router-dom';
import { _axios } from '../../../utils/axios';
import style from '../../../pages/login/login.module.css'

type ActionDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  actionType: string;
  imageSrc: string;
  title: string;
  description: string;
  navigateTo: string;
};

function ActionDialog({
  isOpen,
  onClose,
  actionType,
  imageSrc,
  title,
  description,
  navigateTo,
}: ActionDialogProps) {
  const navigate = useNavigate();
  const [existingLogo, setExistingLogo] = useState<string>('');
  const [logoUrl, setLogoUrl] = useState<string>('');

  useEffect(() => {
    const fetchImages = async () => {
      try {
        // Fetch logo
        const logoResponse = await _axios.get(`${BASE_URL}/api/logo`);
        if (logoResponse.data.success === 1) {
          setLogoUrl(logoResponse.data.url);
          if (logoResponse.data.filename) {
            setExistingLogo(logoResponse.data.filename);
          }
        }
      } catch (error) {
        console.error('Error fetching images:', error);
      }
    };

    fetchImages();
  }, []);

  const handleClick = () => {
    navigate(navigateTo, { state: { isUpdated: true } });
    onClose();
  };

  return (
    <Dialog
      className="fixed inset-0 flex items-center justify-center"
      onClose={onClose}
      open={isOpen}
    >
      <div
        className="w-full max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl py-4 sm:py-6 md:py-8 lg:py-10 xl:py-6 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 cursor-pointer"
        onClick={handleClick}
      >
        <div className="p-2  flex justify-center items-center">
          {/* <img src={`${BASE_URL}/api/logo`} alt="Logo" /> */}
          {logoUrl && (
            <img
              src={logoUrl}
              alt="Logo"
              className={style.companyIcon}
            />
          )}
        </div>
        <div className="pb-6">
          <div className="flex justify-center items-center">
            {/* <div className="w-1/2 md:w-2/5 lg:w-1/3 aspect-square relative"> */}
            <img
              src={imageSrc}
              alt={actionType}
              className="w-[50%] h-auto"
            />
          </div>

          {/* </div> */}
          <h1 className={`text-center ${actionType === 'approved' ? 'text-green-400' : 'text-red-400'} text-2xl font-600 mt-2`}>
            {title}
          </h1>
          <h3 className='text-center text-lg mt-6 font-600'>
            {description}
          </h3>
        </div>
      </div>
    </Dialog>
  );
}

export default ActionDialog;
